import moment from 'moment';

export const nodes = (state) => state.nodes
  .map((node) => {
    const birthDate = moment(node.patient.birthdate, 'YYYY-MM-DD').format('YYYY');

    return {
      text: `${node.subjectId} (${birthDate})`,
      patientId: node.patient.patientId.toString(),
    };
  });

export const list = (state) => state.nodes;

export const selectedPatient = (state) => state.selectedPatient || {};

export const isResetRequired = (state) => state.isResetRequired;
